module.exports = __webpack_public_path__ + "img/PL08666.233681a4.png";